/**
 * attribution.js - lightweight first-touch campaign attribution.
 *
 * Reads utm_* + click-id params off the URL (paid Meta traffic to /start)
 * and stashes them in sessionStorage so they can be attached to whatever
 * the visitor does next (e.g. the matcher OTP-step capture) WITHOUT
 * touching the locked Mini Matcher's own question/OTP/lead logic.
 *
 * First-touch: we never overwrite an already-captured non-empty value in
 * the same tab, so the original ad that brought them in wins.
 */

const KEY = 'bp.attribution';
const FIELDS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid'];

export function captureAttribution() {
  if (typeof window === 'undefined') return {};
  let stored = {};
  try { stored = JSON.parse(window.sessionStorage.getItem(KEY) || '{}') || {}; } catch { stored = {}; }
  const params = new URLSearchParams(window.location.search);
  let changed = false;
  FIELDS.forEach((f) => {
    const v = params.get(f);
    if (v && !stored[f]) { stored[f] = v.slice(0, 200); changed = true; }
  });
  if (changed) {
    try { window.sessionStorage.setItem(KEY, JSON.stringify(stored)); } catch { /* ignore */ }
  }
  return stored;
}

export function getAttribution() {
  if (typeof window === 'undefined') return {};
  try { return JSON.parse(window.sessionStorage.getItem(KEY) || '{}') || {}; } catch { return {}; }
}

export function hasAttribution() {
  return Object.keys(getAttribution()).length > 0;
}
